import React, { useContext, useRef, useEffect, useState } from "react";
import { NavLink, Link, useHistory, useLocation } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import { logout, getLocation } from "../../../API/userData";
import useToggle from "../../../utils/useToggle";
import useWidth from "../../../utils/useWidth";
import WebLinks from "./WebLinks";
import MobileLinks from "./MobileLinks";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import "./Header.css";
import isAuthenticate from "../../../utils/auth";
import { ModalContext } from "../../../context/ModalContext";
import Login from "../../../Themes/Theme1/Login";
import Signup from "../../../Themes/Theme1/Signup";
import RegisterBidPop from "../../../Themes/Theme1/Signup/RegisterBidPop";
import SearchBar from "../../atoms/SearchBar";
import CustomDrawer from "../CustomDrawer";
import { Modal } from "@material-ui/core";
import PrimaryButton from "../../atoms/PrimaryButton";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: "2px 8px",
    width: "275px",
  },
  mobileFormControl: {
    margin: theme.spacing(1),
    width: "163px",
    marginBottom: "5px",
  },
  formControldiv: {
    width: "300px",
  },
  mobileFormControldiv: {
    width: "170px",
    marginBottom: "3px",
  },
}));
const getModalStyle = () => {
  const top = 50;
  const left = 50;

  return {
    position: "absolute",
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
    maxWidth: "500px",
    width: "90%",
    outline: "none",
    textAlign: "left",
  };
};
const Header = ({ store_data }) => {
  const ref = useRef(null);
  const [width] = useWidth(ref);
  const [propertyLoc, setPropertyLoc] = useState([]);
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const [selectedLocation, setSelectedLocation] = useState({
    id: "",
    title: "",
    lat: "",
    lng: "",
  });
  const {
    userLoggedIn,
    userDetails,
    userLocation,
    headerLocation,
    mapRadius,
    storeDetails,
    bid,
  } = useContext(GlobalContext);
  const { isLoginOpen, isSignupOpen, isRegisterToBidOpen } =
    useContext(ModalContext);
  const [menu, toggleMenu] = useToggle(false);
  const site_id = localStorage.getItem("site_id");
  const [modalStyle] = useState(getModalStyle);
  // const [govModalOpen, setGovModalOpen] = useState(false);
  // const handleGovModal = () => {
  //   setGovModalOpen((prevModalStatus) => !prevModalStatus);
  // };
  // useEffect(() => {
  //   if (window.location.pathname === "/") {
  //     setGovModalOpen(true);
  //   }
  // }, []);
  // useEffect(() => {
  //   if (site_id != null) {
  //     propertyLocation();
  //   }
  // }, [site_id]);

  // useEffect(() => {
  //   let url = new URLSearchParams(location.search);
  //   if (site_id != null && url.get("load") === "true") {
  //     propertyLocation();
  //   }
  // }, [location]);

  // useEffect(() => {
  //   if (headerLocation.get) {
  //     setSelectedLocation(headerLocation.get);
  //   }
  // }, [headerLocation.get]);

  // useEffect(() => {
  //   if (mapRadius.get) {
  //     let newValue = mapRadius.get;
  //     let url = new URLSearchParams(location.search);
  //     let locIndex = propertyLoc.findIndex((e) => e.id === newValue.id);
  //     if (locIndex !== -1) {
  //       let newLocation = [...propertyLoc];
  //       newLocation[locIndex].radius = newValue.radius;
  //       newLocation[locIndex].title = newValue.title;
  //       newLocation[locIndex].lat = newValue.lat;
  //       newLocation[locIndex].long = newValue.lng;
  //       setPropertyLoc(newLocation);
  //       if (selectedLocation.id === newValue.id) {
  //         url.set("radius", newValue.radius);
  //         url.set("title", newValue.title);
  //         url.set("lat", newValue.lat);
  //         url.set("long", newValue.lng);
  //         history.replace({
  //           pathname: `/search`,
  //           search: "?" + url.toString(),
  //         });
  //       }
  //     }
  //   }
  // }, [mapRadius.get]);

  // useEffect(() => {
  //   if (location.pathname !== `/search` && headerLocation.get.id !== "") {
  //     headerLocation.set({
  //       id: "",
  //       title: "",
  //       lat: "",
  //       lng: "",
  //     });
  //   }
  // }, [location.pathname, headerLocation.get]);

  // const propertyLocation = async () => {
  //   let url = new URLSearchParams(location.search);
  //   let data = await getLocation(site_id);
  //   if (data && data.length > 0) {
  //     setPropertyLoc(data);
  //     if (url.get("load") === "true") {
  //       let defaultLocation = data[0];
  //       url.set("cities", "");
  //       url.set("state", "");
  //       url.set("radius", defaultLocation.radius);
  //       url.set("title", defaultLocation.title);
  //       url.set("lat", defaultLocation.lat);
  //       url.set("long", defaultLocation.lng);
  //       url.set(
  //         "north",
  //         calculateNewLatLong(defaultLocation.lat, defaultLocation.radius, 0)
  //       );
  //       url.set(
  //         "south",
  //         calculateNewLatLong(defaultLocation.lat, defaultLocation.radius, 180)
  //       );
  //       url.set(
  //         "east",
  //         calculateNewLatLong(defaultLocation.lng, defaultLocation.radius, 90)
  //       );
  //       url.set(
  //         "west",
  //         calculateNewLatLong(defaultLocation.lng, defaultLocation.radius, 270)
  //       );
  //       url.set("load", false);
  //       history.replace({
  //         pathname: `/search`,
  //         search: "?" + url.toString(),
  //       });
  //     }
  //   }
  // };

  // const calculateNewLatLong = (startingPoint, radiusMiles, bearing) => {
  //   let numDegrees = Number(radiusMiles) / 69;
  //   if (bearing === 0 || bearing === 90)
  //     return Number(startingPoint) + numDegrees;
  //   if (bearing === 180 || bearing === 270)
  //     return Number(startingPoint) - numDegrees;
  // };

  const handleUpdateClick = (id, email) => {
    history.push({
      pathname: `/signup`,
      state: {
        action: "userUpdate",
        user_id: id,
        values: { email },
      },
    });
  };

  return (
    <>
      <div className="header-container">
        <header ref={ref} className="header-warpper-beforelg">
          {/* <p className="text-center emergencyText">
            Due to the government shutdown, listings have been suspended for the
            time being. For more information and updates,{" "}
            <Link button onClick={handleGovModal}>
              click here
            </Link>
            .
          </p> */}
          <nav className="navbar navbar-expand-lg" role="navigation">
            <div className="navbar-header d-lg-block">
              {window.location.pathname.includes("/search") ||
              window.location.pathname.includes("/auctions") ? (
                <CustomDrawer
                  anchor="top"
                  customClass="searchBarChange"
                  buttonLabel={<span className="material-icons">search</span>}
                  drawerClass="search-top"
                >
                  <div className="search-input-wrap">
                    <FormControl
                      variant="outlined"
                      className={`${
                        !width ? classes.mobileFormControl : classes.formControl
                      } headerSpecial`}
                    >
                      <SearchBar from="header" fullWidth={true} />
                    </FormControl>
                  </div>
                </CustomDrawer>
              ) : null}
              <Link
                className={
                  window.location.pathname.includes("/search") ||
                  window.location.pathname.includes("/auctions")
                    ? "navbar-brand"
                    : "navbar-brand ml-0"
                }
                to={`/`}
              >
                <img
                  className="img-responsive hm-logo f"
                  src="/images/mylogo.png"
                  alt="MyNextBid"
                />
              </Link>
            </div>

            {window.location.pathname.includes("/search") ||
            window.location.pathname.includes("/auctions") ? (
              <div className="mobileViewTest headerSide w-100">
                <FormControl
                  variant="outlined"
                  className={`${
                    !width ? classes.mobileFormControl : classes.formControl
                  } headerSpecial`}
                >
                  <SearchBar from="header" fullWidth={true} />
                </FormControl>
              </div>
            ) : null}
            <MobileLinks width={width} store_data={store_data} menu={menu} />
          </nav>
        </header>
      </div>

      {!window.location.pathname.includes("/property") && (
        <>
          {isAuthenticate() && userDetails.get["status"] === "incomplete" && (
            <div
              className={`${
                window.location.pathname.includes(`/search`) ? "srchPdg" : ""
              } usrRegCheck`}
            >
              <p>
                Your account is incomplete, please{" "}
                <a
                  onClick={() =>
                    handleUpdateClick(
                      userDetails.get["id"],
                      userDetails.get["email"],
                    )
                  }
                >
                  click here
                </a>{" "}
                to update your account info
              </p>
            </div>
          )}
        </>
      )}

      {isLoginOpen && <Login />}
      {isSignupOpen && <Signup />}

      {isRegisterToBidOpen && <RegisterBidPop />}
      {/* <Modal
        open={govModalOpen}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="govModal"
      >
        <div style={modalStyle}>
          <p className="text-center">
            Due to the current government shutdown, all listings associated with
            the USDA have had to be suspended for the time being, which has
            impacted our ability to provide listings through our system. We hope
            to be able to restore services in the near future.
          </p>
          <p className="text-center">
            Please check back for updates, and if you would like to be kept
            up-to-date on future opportunities, send us an email at
            support@mynextbid.com.
          </p>
          <PrimaryButton onClick={handleGovModal}>Ok</PrimaryButton>
        </div>
      </Modal> */}
    </>
  );
};

export default Header;
